
export const Constant = {
	GOOGLE_LOGIN_CLIENT_ID: (process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID as string),
	FACEBOOK_LOGIN_APP_ID: (process.env.REACT_APP_FACEBOOK_LOGIN_APP_ID as string),
	APPLE_LOGIN_CLIENT_ID: (process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID as string),
	STRIPE_KEY: (process.env.REACT_APP_STRIPE_KEY as string),
	STRIPE_SECRET_KEY: (process.env.REACT_APP_STRIPE_SECRET_KEY as string),
};
